export const SEARCH_CITY_STARTED = 'city/SEARCH_CITY_STARTED';
export const SEARCH_CITY_SUCCEEDED = 'city/SEARCH_CITY_SUCCEEDED';
export const SEARCH_CITY_FAILED = 'city/SEARCH_CITY_FAILED';

export const SELECT_PAGE_SIZE = 'city/SELECT_PAGE_SIZE';
export const SELECT_PAGE_INDEX = 'city/SELECT_PAGE_INDEX';

export const REMOVE_CITY = 'REMOVE_CITY';
